<template>
  <div id="point">
    <div class="point-info" ref="point">
      <div class="left">
        <div class="title">{{ pointInfo.pointName }}</div>
        <div class="content-box">
          <div class="box-item">
            <div class="label">类别</div>
            <div class="value">{{ getTypeName }}</div>
          </div>
          <div class="box-item">
            <div class="label">编码</div>
            <div class="value">{{ pointInfo.code }}</div>
          </div>
          <div class="box-item">
            <div class="label">监督电话</div>
            <div class="value">{{ phoneList }}</div>
          </div>
          <div class="box-item">
            <div class="label">网格长</div>
            <div class="value">{{ pointInfo.streetChiefName }}</div>
          </div>
          <div class="box-item">
            <div class="label">网格长电话</div>
            <div class="value">{{ pointInfo.streetChiefPhone }}</div>
          </div>
          <div class="box-item">
            <div class="label">地址</div>
            <div class="value">{{ pointInfo.pointAdress }}</div>
          </div>
        </div>
      </div>
      <div class="right">
        <!-- <img src="@/assets/image/ewm.png" alt="" /> -->
        <img :src="imgUrl" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { preview, previewBase } from "@/api/point.js";
import html2canvas from "html2canvas";
export default {
  props: {
    pointInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    pointType: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      phoneList: "",
      imgUrl: ""
    };
  },
  mounted() {},
  methods: {
    downloadImg() {
      let posterImage = this.$refs.point;
      const clientWidth = posterImage.offsetWidth;
      const clientHeight = posterImage.offsetHeight;
      const kh = [clientWidth, clientHeight];

      html2canvas(posterImage, {
        useCORS: true,
        logging: true
      }).then(canvas => {
        const dataURL = canvas.toDataURL("image/png");
        this.download(dataURL, kh);
      });
    },
    getUrlBase64(url, kh) {
      return new Promise(resolve => {
        let canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();
        img.crossOrigin = "Anonymous"; // 允许跨域
        img.src = url;
        img.onload = () => {
          // eslint-disable-next-line prefer-destructuring
          canvas.height = kh[1];
          // eslint-disable-next-line prefer-destructuring
          canvas.width = kh[0];
          ctx.drawImage(img, 0, 0, kh[0], kh[1]);

          const dataURL = canvas.toDataURL("image/png");
          canvas = null;
          resolve(dataURL);
        };
      });
    },
    download(imgUrl, kh) {
      this.getUrlBase64(imgUrl, kh).then(base64 => {
        const link = document.createElement("a");
        link.href = base64;
        link.download = `点位码.png`;
        link.click();
      });
    },
    async getImg() {
      // 预览二维码
      // const res = await preview([this.pointInfo.qrCodeUrl]);
      const resdata = await previewBase({
        id: this.pointInfo.id
      });
      this.imgUrl = resdata.data.data;
    }
  },
  computed: {
    getTypeName() {
      let name = "";
      if (this.pointType.length) {
        this.pointType.forEach(item => {
          if (item.id == this.pointInfo.pointTypes) {
            name = item.typeName;
          }
        });
      }
      return name;
    }
  },
  watch: {
    pointInfo: {
      handler() {
        this.getImg();
        if (this.pointInfo.consultationHotline) {
          this.phoneList = JSON.parse(this.pointInfo.consultationHotline)
            .map(item => item.phone)
            .join("、");
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style scoped lang="less">
#point {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3faff;
  padding: 36px 0;

  .point-info {
    height: 592px;
    width: 840px;
    background: url("~@/assets/image/point-bg.png") no-repeat center;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    padding: 190px 48px 40px;

    .left,
    .right {
      width: 50%;
      height: 100%;
      padding: 24px;
    }

    .left {
      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 700;
        font-size: 22px;
        color: #333333;
      }

      .content-box {
        margin-top: 24px;

        .box-item {
          margin-bottom: 16px;
          display: flex;
          align-items: baseline;
          height: 20px;

          .label {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            margin-right: 24px;
            width: 100px;
            padding: 0;
            text-align: justify;
            white-space: break-spaces;
          }

          .label:after {
            display: inline-block;
            width: 100%;
            content: "";
          }

          .value {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
          }
        }
      }
    }
    .right {
      padding: 36px 48px;
      margin: 0 auto;
      img {
        height: 261px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/point/motherChildPoint/components/point.vue